import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/Manage-my-account-q3-01-movil.png")